module.exports = __webpack_public_path__ + "static/robotsmeta-644f236379703a96c2a492e1cd3a0d94.png";